/* eslint-disable react/prop-types */
import React from 'react';
import { periods } from '../constants';
import { SegmentedControl } from './ui';

const PeriodButtons = ({ handleChangeTime, activePeriod }) => {
  const handleButtonClick = value => {
    handleChangeTime(value);
  };

  return (
    <SegmentedControl
      className="w-full justify-center sm:w-auto"
      items={Object.entries(periods).map(([key, value]) => ({
        value,
        label: key.charAt(0) + key.slice(1).toLowerCase()
      }))}
      value={activePeriod}
      onChange={handleButtonClick}
    />
  );
};

export default PeriodButtons;
